import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "wmus010";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const Svg = props => <Wrapper>
    <svg {...props} aria-hidden />
  </Wrapper>;

require("./svg.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./svg.js");